import Vue from 'vue';
import App from './ui/App.vue';

new Vue({
  el: '#app',
  render: h => h(App)
});
